<template>
  <div class="tab-bar">
    <div class="tab-bar-item" :class="router.path === item.pagePath ? 'active':''" v-for="(item, index) in tabBarConfig" :key="index" @click="handleSelectTabBarItem(item)">
      <hkj-svg :iconName="item.iconName"></hkj-svg>
      <!-- <img :src="router.path === item.pagePath ? item.selectedIconPath : item.iconPath" @click="handleSelectTabBarItem(item)"> -->
      <div class="title">{{ item.text }}</div>
    </div>
  </div>
</template>
<script>
import TabBarConfig from '@/config/tabbarConfig.js'
import HkjSvg from '@/components/svg/index.vue'
import { loginStore } from '@/store';
export default {
  components:{
    HkjSvg
  },
  props: {
    router: Object
  },
  data() {
    return {
      tabBarConfig: [],
      loginType: ''
    }
  },
  created() {
    this.loginType = loginStore.getLoginType()
    this.generateData()
  },
  methods: {
    generateData() {
      if (this.loginType === 'ic') {
        this.tabBarConfig = [TabBarConfig[0],TabBarConfig[3],TabBarConfig[4]]
      } else {
        this.tabBarConfig = TabBarConfig
      }
    },
    handleSelectTabBarItem(item) {
      const username = localStorage.getItem('username') || sessionStorage.getItem('username')
      if (item.pagePath.startsWith('http://') || item.pagePath.startsWith('https://')) {
        // 外部链接：将username作为参数拼接到URL中
        const url = new URL(item.pagePath)
        if (username) {
          url.searchParams.set('username', username)
        }
        window.location.href = url.toString()
      } else {
        // 内部路由：通过query或params传递
        if (username) {
          this.$router.push({
            path: item.pagePath,
            query: {
              //username: username
            }
          })
        } else {
          this.$router.push(item.pagePath)
        }
      }
    }
  }
}
</script>
<style scoped>
.tab-bar {
  position: fixed;
  bottom: 0;
  /* width: 100%; */
  /* max-width: 26.875rem; */
  height: var(--len60);
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  z-index: 999999;
}
.tab-bar-item{
  text-align: center;
  flex: 1;
}
.tab-bar-item img{
  width: var(--len30);
  height: var(--len30);
  margin-top: var(--len5);
}
.tab-bar-item .title{
  margin-top: var(--len_5);
  font-size: var(--len12);
  color: gray;
}
.tab-bar-item.active .title{
  color: var(--primary-color);
}
</style>